export default {
  firstName: {
    presence: { allowEmpty: false },
    format: {
      pattern: /^[a-zA-Z_-]+( [a-zA-Z_-]+)*$/
    },
    length: {
      maximum: 35,
      message: 'should be less than 35 character'
    }
  },
  lastName: {
    presence: { allowEmpty: false },
    format: {
      pattern: /^[a-zA-Z_-]+( [a-zA-Z_-]+)*$/
    },
    length: {
      maximum: 35,
      message: 'should be less than 35 character'
    }
  },
  email: {
    presence: { allowEmpty: false },
    email: true
  },
  phone: {
    presence: { allowEmpty: true }
  }
};
